export const state = { stopReason: "manual" };
export const setState = (newState) => Object.assign(state, newState);
